<template>
	<div class="filelibrary">
		<headerview :cur="4"></headerview>
		
		<div class="content">
			
			<div class="moddlecon w13 min-h">
				<div class="tipcon">
					<tipcon :title="'文件库'" :name="'文件库'" :imgtype="'2'" width="1.73"></tipcon>
				</div>
				
				<div class="listcon_public">
					<div class="signle" v-for="(item,index) in list" :key="index" @click="seedetail(item)">
						<div class="title overfh" :title="item.title">{{item.title||''}}</div>
						<div class="time">{{item.createTime.split(' ')[0] || ''}}</div>
					</div>
				</div>
				
				<!-- 分页 -->
				<div class="">
					<div is='footPage' class="zhini-pagination"
					  :currentPage="pageNo"
					  :totalPage="total"
					  @pageNum="pageNum"  :pagesize='pageSize'></div>
				</div>
				
				
			</div>	
		</div>
		
		<footview></footview>
		
	</div>
	
</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import footPage from '../../../components/footpage/footpage.vue'

export default {
  components: {
  	  tipcon,
	  footPage,
  },
  data: function() {
    return {
		list:[],
		pageNo:1,
		total:5,
		pageSize:5,
	  
    };
  },
  
  mounted() {
		this.$onScrollT()
		this.getCulturallist()
  },

  methods: {
	    getCulturallist(){
	    	  this.$get(`web/culturalproduct/datalist?pageSize=8&pageNo=${this.pageNo}&dataType=0`).then(res=>{
	    		  if(res.success){
					  this.total = res.result.total
	    			  this.list = res.result.records;
	    		  }
	    	  })
	    },
		
	    seedetail(item){
			this.$router.push({ path: '/textdetail?id='+item.id +'&type=1'});			
		},
		
		pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getCulturallist()
		},
		
		
		
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.filelibrary{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			.title{
				width: calc(100% - 120px);
			}
		}
			
	}
			
	
	
}

</style>
